<div class="modal-header">
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        <div>
            <div class="row g-2">
                <div class="d-flex align-items-center justify-content-center">
                    <img [src]="data.img" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
